import React, { Component } from 'react';
import PropTypes from 'prop-types';
import syncPushState from '../../lib/syncPushState';
import Filter from './Filter';

export default class TextFilter extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    selected: PropTypes.string,
    onChange: PropTypes.func,
  }

  static defaultProps = {
    selected: null,
    placeholder: null,
    onChange() {},
  }

  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selected,
      placeholder: this.props.placeholder || this.props.title,
    };

    this.inputRef = React.createRef();
  }

  handleChange = (e) => {
    const selected = e.target.value === '' ? null : e.target.value;

    this.setState({ selected }, () => {
      syncPushState(this.props.id, selected);
      this.props.onChange('selected', { id: this.props.id, selected });
    });
  }

  handleLocalResetClick = () => {
    const selected = null;
    this.setState({ selected }, () => {
      syncPushState(this.props.id, selected);
      this.props.onChange('selected', { id: this.props.id, selected });
    });
    this.inputRef.current.value = '';
  }

  handleGlobalResetClick = () => {
    const selected = null;
    this.setState({ selected }, () => {
      this.props.onChange('selected', { id: this.props.id, selected });
    });
    this.inputRef.current.value = '';
  }

  render() {
    const {
      id, title, expanded, onChange,
    } = this.props;
    const defaultValue = this.state.selected;
    return (
      <Filter
        id={id}
        title={title}
        expanded={expanded}
        hasSelected={this.state.selected !== null}
        onChange={onChange}
        onLocalReset={this.handleLocalResetClick}
        onGlobalReset={this.handleGlobalResetClick}
      >
        <div className="Form u-px-4 u-pb-2">
          <input
            type="text"
            defaultValue={defaultValue}
            placeholder={this.state.placeholder}
            onChange={this.handleChange}
            ref={this.inputRef}
          />
        </div>
      </Filter>
    );
  }
}
